import { RichTextReadOnly } from 'mui-tiptap'
import { useExtensions } from './useExtensions'

const ReadOnlyTextEditor = ({ content = '' }) => {
  const extensions = useExtensions({
    placeholder: 'Write something...'
  })

  return (
    <>
      <RichTextReadOnly content={content} extensions={extensions} />
    </>
  )
}

export default ReadOnlyTextEditor
